module.exports = __webpack_public_path__ + "static/media/addIcon.c20c09b2.svg";